module.exports = __webpack_public_path__ + "static/media/boate.94c94a5c.jpg";